import { useCallback, useMemo, useState } from 'react'

import { ClusterContext } from './context'

export const CreatorClustersProvider = ({ children }) => {
  const [clusterId, setClusterId] = useState(null)
  const [clusterInfo, setClusterInfo] = useState(null)

  const handleClusterClick = useCallback(
    (id, type, title) => {
      setClusterId(id)
      setClusterInfo({
        type,
        title,
      })
    },
    [setClusterId, setClusterInfo]
  )

  const contextValue = useMemo(
    () => ({
      clusterId,
      setClusterId,
      clusterInfo,
      setClusterInfo,
      handleClusterClick,
    }),
    [clusterId, setClusterId, clusterInfo, setClusterInfo, handleClusterClick]
  )

  return <ClusterContext.Provider value={contextValue}>{children}</ClusterContext.Provider>
}
